import AddIcon from '@mui/icons-material/Add';
import {
    Button,
    Card,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useIntegrations } from '../../../sic-lib/api/hooks/useIntegrations';
import Loader from '../../Shared/Loader';
import CreateIntegrations from './CreateIntegrations';
import IntegrationsTableItem from './IntegrationsTableItem';

export default function IntegrationsSettings() {
    const { classes } = useStyles();

    const [openCreateIntegration, setOpenCreateIntegration] = React.useState<boolean>(false);

    const { data: integrationData, isLoading: isIntegrationLoading } = useIntegrations();

    const handleCreate = () => {
        setOpenCreateIntegration(!openCreateIntegration);
    };

    return (
        <Loader isLoading={isIntegrationLoading}>
            <>
                {!openCreateIntegration ? (
                    <Button
                        onClick={handleCreate}
                        className={classes.marginBot}
                        startIcon={<AddIcon />}
                    >
                        Create Integrations
                    </Button>
                ) : (
                    <CreateIntegrations
                        integrationData={integrationData}
                        onCloseHandler={handleCreate}
                    />
                )}
                <Card>
                    <CardHeader title="Integrations" />
                    <Divider />
                    <Table aria-label="integration table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell align="left">Key</TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {integrationData &&
                                integrationData.map(itm => (
                                    <IntegrationsTableItem
                                        key={itm.id}
                                        id={itm.id}
                                        sourceKey={itm.key}
                                        sourceId={itm.sourceId}
                                    />
                                ))}
                        </TableBody>
                    </Table>
                </Card>
            </>
        </Loader>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    marginBot: {
        marginBottom: theme.spacing(2),
    },
}));
